import { Log, apiRequest, Wait } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Publicacion.types';
import { IPublicacion } from './Publicacion.lib';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { Articulo } from '@/__env/lib/Articulos';
import { Estados, Tipos } from '@/__env/lib/MercadoLibre/Publicaciones/Publicacion.types';

export class Publicacion extends IPublicacion
{

    public static async create( id: string, cuenta: string = null ): Promise<Publicacion>
    {
        let o = new Publicacion();
        o.Id = id;
        if ( cuenta )
            o.Cuenta = cuenta;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/mercadolibre/publicaciones';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( this.Cuenta )
            request.params.cuenta = this.Cuenta;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Publicacion>; Error?: boolean; }>
    {

        let a: Array<Publicacion> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/mercadolibre/publicaciones` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Publicacion( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {


            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public static async Descargar( cuenta: string, id: string )
    {
        let request = new apiRequest( `/mercadolibre/publicaciones/e/${cuenta}/${id}` );

        if ( await request.post() )
        {
            return true;
        }
    }

    public static async DescargarTodo( cuenta: string ): Promise<{ Total: number, Proceso: string; }>
    {
        let request = new apiRequest( `/mercadolibre/publicaciones/e/${cuenta}` );
        request.timeOut = 100000;
        if ( await request.post() )
        {
            return { Total: request.data.total, Proceso: request.data.process };
        }
    }

    public static async ModificarPrecios( coeficiente: number ,filtros:any): Promise<{ Total: number, Proceso: string; }>
    {
        let request = new apiRequest( `/mercadolibre/global/publicaciones/precios` );
        request.timeOut = 100000;
        request.body = {
            coeficiente: coeficiente,
            filtros: filtros
        }
        if ( await request.post() )
        {
            return { Total: request.data.total, Proceso: request.data.process };
        }
    }

    public async Modificar( stock: number = null, precio: number = null ): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( stock )
                    req.params.stock = stock;
                if ( precio )
                    req.params.precio = precio;
                if ( await req.put() )
                {

                    if ( stock )
                        this.Stock = stock;
                    if ( precio )
                        this.Precio = precio;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async ModificarDescripcion( descripcion: string, codigo: string = null ): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}/descripciones`;
                req.params.descripcion = descripcion;
                if ( codigo )
                    req.params.codigo = codigo;
                if ( await req.put() )
                {
                    this.Descripcion = descripcion;
                    if ( codigo )
                        this.Codigo = codigo;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public EditarDescripcion( codigo: Articulo ): string
    {

        let editado = false;
        let descripcion: string = '';
        if ( this.Codigo && this.Descripcion.includes( this.Codigo ) )
        {
            descripcion = this.Descripcion.replace( this.Codigo, codigo.Id );
            editado = true;
        }
        /*
        if ( this.Existe )
        {

            let code: string = '';

            let CodeTest: string[] = ["CODIGO:", "SKU:", "CÓDIGO:", "CODIGO", "SKU", "CÓDIGO"];
            let lineas = this.Descripcion.split( '\n' );
            for ( let item of lineas )
            {
                descripcion += item + '\n';
                code = '';
                if ( item && item.length < 30 )
                {
                    for ( let test of CodeTest )
                    {
                        if ( item.toUpperCase().trim().startsWith( test ) )
                        {
                            code = item.toUpperCase().eliminar( test ).eliminar( ':' ).eliminar( ' ' ).trim().formatearCodigoArticulo();
                            if ( code && code.trim().length == 7 && code.eliminar( '/' ).toInt() > 0 )
                            {
                                descripcion.eliminar( item );
                                console.log( code, item );
                                descripcion += 'CODIGO: ' + codigo.Id + '\n';
                                editado = true;
                            }

                        }
                    }

                }


            }
            */

        if ( editado )
        {
            return descripcion;
        }
        else
        {
            console.log( 'CODIGO: ' + codigo.Id + '\n\n' + '\n' + this.Descripcion );
            return 'CODIGO: ' + codigo.Id + '\n\n' + '\n' + this.Descripcion;
        }
    }

    public async Pausar(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                req.params.estado = 'paused';
                if ( await req.put() )
                {
                    this.Estado = Estados.Pausada;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }


    public async ConvertirEnFinaciada(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                req.params.tipo = 'gold_pro';
                if ( await req.put() )
                {
                    this.Tipo = Tipos.Financiada;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }


    public async Duplicar( cuenta: string, precio?: number, stock?: number, tipo?: string ): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `/mercadolibre/publicaciones/ope/duplicar`;
                req.body = {
                    ids: this.Id,
                    origen: this.Cuenta,
                    destino: cuenta,
                }
                if ( precio ) req.body.precio = precio;
                if ( stock ) req.body.stock = stock;
                if ( tipo ) req.body.tipo = tipo;
                if ( await req.post() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async Activar(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                req.params.estado = 'active';
                if ( await req.put() )
                {
                    this.Estado = Estados.Activa;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async Cerrar(): Promise<boolean>
    {
        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                req.params.estado = 'closed';
                if ( await req.put() )
                {
                    this.Estado = Estados.Cerrada;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async CargarDescripcion()
    {
        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}/descripcion`;
                if ( await req.get() )
                {
                    this.Descripcion = req.data.descripcion;
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;

    }

    public static async URLListado( filtros: any, ids?: string[] ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 10000000;
        req.path = '/mercadolibre/publicaciones/listado';
        if ( ids )
        {
            req.body.ids = ids.join(',');
        } else
        {
            req.body.filtros = filtros;
        }

        req.params.response_type = 'pdf';
        if ( await req.post() )
        {
            return req.data.u;
        }
    }

    public static async URLExcelOfertas( filtros: any, cuenta: string, ids?: string[] ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 10000000;
        req.path = '/mercadolibre/publicaciones/ofertas/listado';
        if ( ids )
        {
            req.body.ids = ids.join(',');
        } else
        {
            //req.body.filtros = filtros;
        }
        req.body.cuenta = cuenta;
        if ( await req.post() )
        {
            return req.data.u;
        }
    }

    public async CalcularEnvio( destino: string | number , origen: string | number): Promise<any>
    {
        let req = new apiRequest();
        req.timeOut = 10000000;
        req.path = `/mercadolibre/costo/mercadoenvios/${this.Cuenta}/${this.Id}`;
        req.body = {
            destino: destino,
            origen: origen,
        };
        if ( await req.post() )
        {
            return req.data;
        }
    }
}